import { isRejectedWithValue } from '@reduxjs/toolkit'
import { ToastVariants } from '../../../constants/variants'
import { show } from '../../reducers/toast'

const getErrorMessage = action => action?.error?.data?.message || action?.error?.message || "Sorry, we've encountered an error."
export const rtkQueryErrorLogger = (api) => (next) => (action) => {
  if (isRejectedWithValue(action)) {
    // Skip toast for errors handled by the frontend (e.g. notes shortening confirmation)
    const errorCode = action?.payload?.data?.error
    if (errorCode === 'NOTES_SHORTENED') return next(action)

    api.dispatch(show({ message: getErrorMessage(action), variant: ToastVariants.DANGER, withIcon: true }))
  }

  return next(action)
}